// Models
import { CustomChecklistActionTypes } from 'app/shared/customChecklist/models';

// Reducers
import { initialState } from 'app/shared/customChecklist/reducer';

export const selectCustomChecklistContent = (state: RootState) => {
  return (
    state.customChecklist || {
      ...initialState,
    }
  ).content;
};

export const selectCustomChecklistDefinition = (state: RootState) => {
  return (
    state.customChecklist || {
      ...initialState,
    }
  ).definition;
};

export const selectCustomChecklistId = (state: RootState) => {
  return (
    state.customChecklist || {
      ...initialState,
    }
  ).checklistId;
};

export const selectCustomChecklistHistory = (state: RootState) => {
  return (
    state.customChecklist || {
      ...initialState,
    }
  ).history;
};

export const selectRetrieveCustomChecklistPending = (state: RootState) =>
  Boolean(state.loading[CustomChecklistActionTypes.RETRIEVE_CUSTOM_CHECKLIST]);
